<template>
  <div id="app">
    <component :is="layout">
      <router-view :key="$route.fullPath" />
    </component>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

const DEFAULT_LAYOUT = 'default';

export default defineComponent({
  computed: {
    layout(): string {
      return (this.$route.meta?.layout || DEFAULT_LAYOUT) + '-layout';
    },
  },
});
</script>

<style lang="scss"></style>
